


















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class WaitingApprovePage extends Vue {
  mounted() {
    const vApplicationWrap = document.getElementsByClassName('v-application--wrap')[0] as HTMLElement;
    if (vApplicationWrap) {
      vApplicationWrap.style.setProperty('min-height', '100vh', 'important');
    }
  }
  beforeDestroy() {
    const vApplicationWrap = document.getElementsByClassName('v-application--wrap')[0] as HTMLElement;
    if (vApplicationWrap) {
      vApplicationWrap.style.removeProperty('min-height');
    }
  }
}
